import { Alert, Button, Card } from '@dnx/ui';
import { useMutation, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { Building2, ChevronRight } from 'lucide-react';
import { AuthLayout } from '../components/auth-layout.js';
import { api } from '../lib/api.js';
import { roleLabel } from '../lib/labels.js';
import { meQuery } from '../lib/session.js';

export function SelectOrganizationPage() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const { data: me } = useSuspenseQuery(meQuery);
  const select = useMutation({
    mutationFn: (organizationId: string) => api<void>('/auth/active-organization', { method: 'POST', body: { organizationId } }),
    onSuccess: async () => { await qc.invalidateQueries({ queryKey: ['auth'] }); void navigate({ to: '/' }); },
  });

  return (
    <AuthLayout title={`Olá, ${me.user.name.split(' ')[0]}`} description="Escolha a clínica que você vai acessar agora. Você pode trocar a qualquer momento.">
      {me.organizations.length === 0 ? (
        <Alert tone="warning" title="Nenhuma clínica vinculada">
          Seu usuário ainda não foi vinculado a uma clínica. Fale com o administrador.
        </Alert>
      ) : (
        <ul className="flex flex-col gap-2.5">
          {me.organizations.map((o) => (
            <li key={o.organizationId}>
              <Card className="transition-colors hover:border-primary/40">
                <button type="button" disabled={select.isPending} onClick={() => select.mutate(o.organizationId)}
                  className="flex w-full items-center gap-3.5 rounded-xl p-4 text-left">
                  <span className="grid size-10 place-items-center rounded-lg bg-primary-soft text-primary"><Building2 className="size-5" /></span>
                  <span className="min-w-0 flex-1">
                    <span className="block truncate text-sm font-medium text-fg">{o.tradeName}</span>
                    <span className="block text-xs text-fg-muted">{o.roles.map(roleLabel).join(' · ')}</span>
                  </span>
                  <ChevronRight className="size-4 text-fg-subtle" />
                </button>
              </Card>
            </li>
          ))}
        </ul>
      )}
      {select.error && <Alert tone="danger" className="mt-4">{select.error.message}</Alert>}
      <Button variant="link" className="mt-6 text-fg-muted" onClick={async () => {
        await api('/auth/logout', { method: 'POST' }).catch(() => undefined);
        qc.clear();
        void navigate({ to: '/entrar' });
      }}>Sair</Button>
    </AuthLayout>
  );
}
